import { useState } from "react";

import { Autocomplete, TextField } from "@mui/material";

export const RibbonElementAutocomplete = ({ elementSettings }) => {
	const { name, options, isDisabled, value, setValue, style, disableClearable = true } = elementSettings;

	const [inputValue, setInputValue] = useState("");

	return (
		<div className="ribbon-element-autocomplete-wrapper">
			<Autocomplete
				size="small"
				className="ribbon-element-autocomplete"
				openText="Открыть"
				closeText="Закрыть"
				clearText="Очистить"
				noOptionsText="Нет данных"
				disableClearable={disableClearable}
				getOptionLabel={(option) => (option ? option.name : "")}
				isOptionEqualToValue={(option, value) => option?.id === value?.id}
				value={value}
				onChange={(event, newValue) => {
					setValue(newValue);
				}}
				inputValue={inputValue}
				onInputChange={(event, newInputValue) => {
					setInputValue(newInputValue);
				}}
				options={options}
				renderInput={(params) => (
					<TextField
						{...params}
						label={name}
						disabled={isDisabled}
						InputLabelProps={{
							shrink: true,
						}}
					/>
				)}
				sx={style}
			/>
		</div>
	);
};
